import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { MemberClassEnum } from './year-selection.model';

const API_URL = environment.projectionApi;

@Injectable({providedIn: 'root'})
export class YearSelectionPeojectionQueryService {
  constructor(private http: HttpClient) {}

  getMemberClass(memberId: string): Observable<MemberClassEnum> {
    const endpoint = `${API_URL}/member/${memberId}/memberStatuses/memberClass`;
    return this.http
      .get<MemberClassEnum>(endpoint)
  }
  
}